import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowRight } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ButtonLink from '../ButtonLink';
import Image from '../Image';
import SegmentedControl from '../SegmentedControl';
import css from './ShopSegments.module.scss';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ShopSegments = function ShopSegments(_ref) {
  var segments = _ref.segments,
      title = _ref.title;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var even = index % 2 === 0;
  var segment = segments[index];
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [segments.map(function (s, sIndex) {
      return /*#__PURE__*/_createElement(Image, _objectSpread(_objectSpread({}, s.image), {}, {
        key: s.title,
        className: cc([css.image, _defineProperty({}, css.imageRight, sIndex % 2 !== 0), _defineProperty({}, css.showImage, sIndex === index)])
      }));
    }), /*#__PURE__*/_jsxs("div", {
      className: css.foreground,
      children: [/*#__PURE__*/_jsx("h2", {
        className: cc([css.title, css.topTitle]),
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: css.control,
        children: /*#__PURE__*/_jsx(SegmentedControl, {
          segments: segments.map(function (s, sIndex) {
            return _objectSpread(_objectSpread({}, s), {}, {
              onClick: function onClick() {
                return setIndex(sIndex);
              }
            });
          }),
          selectedIndex: index,
          white: true
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: cc([css.copy, _defineProperty({}, css.copyRight, even)]),
        children: [/*#__PURE__*/_jsx("h2", {
          className: css.title,
          children: segment.title
        }), /*#__PURE__*/_jsx("p", {
          className: css.description,
          children: segment.description
        }), /*#__PURE__*/_jsx(ButtonLink, {
          className: css.desktop,
          white: true,
          big: true,
          medium: true,
          href: segment.url,
          children: segment.cta
        }), /*#__PURE__*/_jsxs("a", {
          className: cc([css.arrowLink, css.mobile]),
          href: segment.url,
          children: [segment.cta, /*#__PURE__*/_jsx(ArrowRight, {})]
        })]
      })]
    })]
  });
};

var imageProps = PropTypes.shape({
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
}).isRequired;
ShopSegments.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    image: imageProps
  })).isRequired,
  title: PropTypes.string.isRequired
};
export default ShopSegments;